export default "images/风险物体提示+前车风险提示.png";